export default __webpack_public_path__ + "static/media/CA-12 Install app pop-up.29c87637.png";